import moment from "moment";
import vue3PhotoPreview from "vue3-photo-preview";
// import "vue3-photo-preview/dist/index.css";
import { createToast } from "mosha-vue-toastify";
// import "mosha-vue-toastify/dist/style.css";

export const plugins = {
  toast: createToast,
  moment: moment,
  vue3PhotoPreview: vue3PhotoPreview,
};
